import PropTypes from "prop-types";
import React from "react";
import { RadioButton as RADIO_BUTTON } from "@toddle-edu/ds-web";

class RadioButton extends React.PureComponent {
  render = () => {
    const {
      isChecked,
      isDisabled,
      label,
      name,
      testId,
      size = this.props.dsVersion === "2.0" ? "medium" : "x-small",
      dsVersion,
      tabIndex,
    } = this.props;

    return (
      <RADIO_BUTTON
        dsVersion={dsVersion}
        size={size}
        disabled={isDisabled}
        checked={isChecked}
        name={name}
        testId={testId}
        tabIndex={tabIndex}
      >
        {label}
      </RADIO_BUTTON>
    );
  };
}

RadioButton.defaultProps = {
  isChecked: false,
  isDisabled: false,
  label: "",
  testId: "",
  dsVersion: "1.0",
};

RadioButton.propTypes = {
  isChecked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  label: PropTypes.string,
  testId: PropTypes.string,
  dsVersion: PropTypes.string,
};

export default RadioButton;
